import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/**
 * PublicOnlyRoute — the inverse of ProtectedRoute.
 *
 * Wraps /login so an already-authenticated user is sent straight to the
 * Chat workspace instead of seeing the login form again. If
 * they were redirected here from a protected route (ProtectedRoute sets
 * location.state.from), send them back there after all once logged in —
 * handled inside Auth.jsx, this component only guards the reverse case.
 */
const PublicOnlyRoute = () => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  if (loading) return null;

  if (isAuthenticated) {
    const redirectTo = location.state?.from?.pathname || '/chat';
    return <Navigate to={redirectTo} replace />;
  }

  return <Outlet />;
};

export default PublicOnlyRoute;
